import React from "react";

export function EmptyState({ children }: { children: React.ReactNode }) {
  return (
    <div className="rounded-md border border-border bg-surface px-md py-lg text-textLight text-sm">
      {children}
    </div>
  );
}
